"use strict";

var VesselSchedule = function () {
  var getVesselSchedules = function( arrival_port_code, departure_port_code, sealine, search_id, weeksahead ) {
    if( arrival_port_code == '' || departure_port_code == '' || weeksahead == '' || sealine == '' ) {
      //formInputsValidationReturnError();
      Swal.fire({
        title: 'Error',
        text: 'Please fill in all the fields',
        confirmButtonText: 'Ok'
      });
      return false;
    }
    sealine = JSON.parse(sealine.replace(/&quot;/g,'"'));
    sealine.forEach(function(sealine) {
      if (!(sealine == 'CMDU' || sealine == 'MAEU')) {
        sealine = 'searates'
      }
      $.ajax({
        type: "GET",
        url: "/get_schedule?liner_scac="+sealine,
        data: {'arrival_port_code': arrival_port_code, 'departure_port_code': departure_port_code, 'sealine': sealine, 'search_id' : search_id, 'weeksahead': weeksahead},
        dataType: "script"
        });
      });
    }
    var sidebarFilters = function() {
      $(document).ready(function() {
        $('#shipping-line-checkboxes').on('change', 'input', function() {
          var data = $('#shipping-line-checkboxes').find('input:checked').map(function() {
            return this.name;
          }).get();
          
          $.ajax({
            url: '/vessel_schedules',
            type: 'GET',
            data: {
              'shipping_lines': data
            },
            dataType: 'script'
          });
        });
        $('#transit-time-checkboxes').on('change', 'input', function() {
          var data = $('#transit-time-checkboxes').find('input:checked').map(function() {
            return this.name;
          }).get();
          $.ajax({
            url: '/vessel_schedules',
            type: 'GET',
            data: {
              'transit_times': data
            },
            dataType: 'script'
          });
        });
      });

    }
  
    return {
      init: function () {
        sidebarFilters();
        },
        getVesselSchedules: function(arrival_port_code, departure_port_code, sealine, search_id, weeksahead) {
          getVesselSchedules(arrival_port_code, departure_port_code, sealine, search_id, weeksahead);
      }
      
    };

}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = VesselSchedule;
}
$(document).ready(function () {
	VesselSchedule.init();
});